import Api from '../../api/index'

const Supplier = {
  namespaced: true,
  state: {
    value: 'my value',

    oneSupplier: null, //to store SHOW response
    allSuppliers: null, //to store SHOW response

    //promises results
    createSupplierWasGood: null,
    createSupplierMessage: null,
    
    updateSupplierWasGood: null,
    updateSupplierMessage: null,

     // less used
    indexSupplierWasGood: null,
    indexSupplierMessage: null,

    showSupplierWasGood: null,
    showSupplierMessage: null,
  },
  getters: {
    getStateValue: state => {
      return state.value;
    }
  },

  mutations: {
    setOneSupplier(state, Supplier){
      state.oneSupplier = Suppliers.data.map(obj=>obj.attributes) // Supplier.data
    },
    setAllSuppliers(state, Suppliers){
      state.allSuppliers = Suppliers.data.map(obj=>obj.attributes) // Suppliers.data
    },

    updateSupplier(state, Supplier){
      console.log(Supplier.data.id)
      console.log(state.allSuppliers.map(o => o.id).indexOf(Supplier.data.attributes.id))
      state.allSuppliers[state.allSuppliers.map(o => o.id).indexOf(Supplier.data.attributes.id)] = {...Supplier.data.attributes}
    },
    pushSupplier(state, Supplier){
      state.allSuppliers.push(Supplier.data.attributes)
    },

    createResponse(state, {was_good, msg}){
      state.createSupplierWasGood = was_good
      state.createSupplierMessage = msg
      setTimeout(() => {
        state.createSupplierWasGood = null
      }, 100);
    },
    updateResponse(state, {was_good, msg}){
      state.updateSupplierWasGood = was_good
      state.updateSupplierMessage = msg
      setTimeout(() => {
        state.updateSupplierWasGood = null
      }, 100);
    },
    indexResponse(state, {was_good, msg}){
      state.indexSupplierWasGood = was_good
      state.indexSupplierMessage = msg
      setTimeout(() => {
        state.indexSupplierWasGood = null
      }, 100);
    },
    showResponse(state, {was_good, msg}){
      state.showSupplierWasGood = was_good
      state.showSupplierMessage = msg
      setTimeout(() => {
        state.showSupplierWasGood = null
      }, 100);
    },

    clearAllSuppliers(state){
      state.allSuppliers = null
    },
    clearOneSupplier(state){
      state.oneSupplier = null
    },
  },

  actions: {
    clearAllSuppliers({commit}){
      commit('clearAllSuppliers')
    },
    clearOneSupplier({commit}){
      commit('clearOneSupplier')
    },

    index(context, filter) {
      Api.Supplier.index(filter)
        .then(response => response.data)
        .then(Suppliers => {
          context.commit('setAllSuppliers', Suppliers);
          context.commit('indexResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('indexResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    show(context, Supplier_id) {
      Api.Supplier.show(Supplier_id)
        .then(response => response.data)
        .then(Supplier => {
          context.commit('setOneSupplier', Supplier);
          context.commit('showResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('showResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    create(context, new_Supplier) {
      Api.Supplier.create(new_Supplier)
        .then(response => response.data)
        .then(Supplier => {
          context.commit('pushSupplier', Supplier); // not often used
          context.commit('createResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('createResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    update(context, Supplier) {
      Api.Supplier.update(Supplier)
        .then(response => response.data)
        .then(Supplier => {
          context.commit('updateSupplier', Supplier); // not often used
          context.commit('updateResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('updateResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
  }

};

export default Supplier;